import React from 'react';
import { Link } from '../router.jsx';

export default function NotFound() {
	return (
		<div className='notfound'>
			<h1 className='notfound__title'>Ups!</h1>
			<p>Diese Seite gibt es nicht (mehr).</p>
			<Link to='/' className='btn btn--primary'>
				Zur Übersicht
			</Link>
		</div>
	);
}
